import { Box, Column, Columns, Inline, Stack, Text } from 'braid-design-system';
import type { ReactNode } from 'react';

import TrackingButtonLink from '../TrackingButtonLink/TrackingButtonLink';

interface Props {
  heading: string;
  description: string;
  image: ReactNode;
  buttonText: string;
  buttonUrl: string;
  tracking: {
    eventName: string;
    actionOrigin: string;
  };
}
export const PromoBanner = ({
  heading,
  description,
  image,
  buttonText,
  buttonUrl,
  tracking,
}: Props) => (
  <Box padding="large" borderRadius="large" background="formAccentSoft">
    <Columns reverse space="gutter" collapseBelow="tablet">
      <Column width="content">
        <Box
          background="surface"
          borderRadius="full"
          padding={{ mobile: 'small', tablet: 'medium' }}
          display="inlineBlock"
        >
          {image}
        </Box>
      </Column>
      <Column>
        <Stack space="medium">
          <Text size="large" weight="strong">
            {heading}
          </Text>
          <Text>{description}</Text>
          <Inline space="none">
            <TrackingButtonLink
              href={buttonUrl}
              target="_blank"
              rel="noopener"
              trackingEventName={tracking.eventName}
              trackingActionOrigin={tracking.actionOrigin}
              trackingData={{ isPrimaryCTA: true }}
            >
              {buttonText}
            </TrackingButtonLink>
          </Inline>
        </Stack>
      </Column>
    </Columns>
  </Box>
);
